import React from 'react';
import { usePager } from '../../../helpers/pagination';
import PageIndicator from '../../Common/PageIndicator';
import Row from './Row';
import SideBar from '../../Common/SideBar';
import SpotlightHeader from '../../Common/Header';
import { DateTime } from 'luxon';
import './TrainingByStore.scss';
const generateDescription = (course, date) => {
  if (!date) return 'N/A';
  const lastUpdatedDate = DateTime.fromISO(date);
  const dateFormatted = lastUpdatedDate.toFormat('MM/dd');
  const timeFormatted = lastUpdatedDate.toFormat('hh:mm a');
  return `${course} completion by store as of ${dateFormatted} at ${timeFormatted}`;
};
const getFormattedData = (data, metadata) => {
  var _metadata$results;
  const {
    top,
    own
  } = data;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const description = generateDescription(data.course_name, data.updated_at);
  const bohLocations = top.slice(0, results);
  const isOwnInRanking = (own === null || own === void 0 ? void 0 : own.ranking) <= results;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  return {
    own,
    description,
    bohLocations,
    isOwnInRanking,
    hide_poweredbyupshow
  };
};
const TrainingByStore = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    bohLocations,
    own,
    isOwnInRanking,
    description,
    hide_poweredbyupshow
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(bohLocations, duration * 1000, playing);
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "training-by-store-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: "ticket-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: "header-location"
  }, "Location"), /*#__PURE__*/React.createElement("p", {
    className: "header-completion"
  }, "Completion Ratio")), page.map((loc, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${loc.location}=${index}`,
    location: loc,
    own: own,
    accent_color: accent_color
  })), !!own && !isOwnInRanking && /*#__PURE__*/React.createElement(Row, {
    key: `${own.location}`,
    location: own,
    own: own,
    accent_color: accent_color
  }), /*#__PURE__*/React.createElement("div", {
    className: "results-description"
  }, "Results ordered by Completion Ratio")), pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  }))), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default TrainingByStore;